import React, { useEffect } from 'react';
import { Accordion } from './Accordion.jsx';
import { useMotion } from '../../hooks/useMotion.js';
import './Faq.css';

const faqItems = [
  {
    title: 'What is an Independent Asset Manager (IAM)?',
    content: (
      <>
        <p>
          An IAM manages client portfolios independently of any bank. Some focus
          on specific areas or investments, while others focus on specific types
          of clients.
        </p>
        <p>
          An IAM provides objective and personalised advice based on a client's
          goals, expectations and risk appetite, in return for a transparent
          fee. IAMs are generally compensated through a fixed percentage
          management fee, so it is in their direct self-interest to stay aligned
          with their clients' interests.
        </p>
        <p>
          Independent asset managers do not hold a client's assets, which gives
          clients the flexibility to choose their preferred private bank and
          keeps the assets secure.
        </p>
        <p>
          In Singapore, IAMs are required to hold a licence for fund management
          issued by the Monetary Authority of Singapore and are regulated
          strictly to protect investors.
        </p>
      </>
    ),
  },
  {
    title: 'How do I choose an IAM?',
    content: (
      <>
        <h4>Range of services</h4>
        <p>
          Beyond core asset management — building a portfolio of equities,
          fixed-income securities and forex — you may also get access to direct
          investment opportunities and alternatives. Many IAMs can also engage
          family office services, trust specialists, fund solutions and capital
          markets. Choose one with expertise in the areas that matter to you.
        </p>
        <h4>Investment strategy and approach</h4>
        <p>
          IAMs should be transparent about their recommended strategy and
          conduct meticulous risk assessment. If you do not fully understand an
          approach or product, ask them to clarify it. A good IAM will answer
          patiently.
        </p>
        <h4>Fees</h4>
        <p>
          IAMs should be upfront and honest about fees. Business models vary
          widely — some generate revenue through retrocessions, others through
          management or performance fees. Comparing costs across firms will show
          you the going rate.
        </p>
        <h4>Size</h4>
        <p>
          A large firm with billions under management will have access to a
          wider range of products, but you may do equally well or better with a
          small firm, because you are more likely to receive personalised
          service aligned to your risk profile and needs.
        </p>
      </>
    ),
  },
  {
    title: 'What are the safeguards I have as a client?',
    content: (
      <>
        <p>Assets are held by private banks under the client's name.</p>
        <p>
          Clients have access to the account via digital private banking, where
          available, and continue to receive transaction advice and statements
          from the private bank.
        </p>
        <p>
          Clients can always contact the bank directly to check any
          irregularities regarding the account.
        </p>
        <p>
          To operate as an IAM in Singapore, the firm must hold the relevant
          licences and is subject to its regulators.
        </p>
      </>
    ),
  },
];

export const Faq = () => {
  useMotion();

  useEffect(() => {
    document.title = 'Frequently Asked Questions | ASTRID FIRST Wealth Advisory';
  }, []);

  return (
    <div className="faq-page">
      <header className="page-head">
        <div className="page-head-inner">
          <p className="crumb">
            <a href="/">Home</a> / Frequently Asked Questions
          </p>
          <h1 data-reveal="chars">Frequently Asked Questions</h1>
          <p className="lead" data-reveal="fade">
            Clear answers on the IAM model, our regulatory standing, and how your
            assets remain protected.
          </p>
        </div>
      </header>

      <div className="spine">
        <section className="section shell">
          <div className="track">
            <div className="track-head track-head--sticky">
              <p className="eyebrow">Common questions</p>
              <h2 data-reveal="lines">Questions &amp; Answers</h2>
            </div>
            <div>
              <Accordion items={faqItems} />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};